// import { db } from '../../config/main_config.js';

// export async function fetchIssueRegister(companyID, enableRealTimeUpdates = false) {
//     console.log(companyID);
//     if (!companyID) {
//         console.error("Company ID is required.");
//         return null;
//     }

//     const documentRef = db.doc(`/customers/${companyID}/product/managementSystemGuide/issueRegister/register`);
//     const oldDocumentRef = db.doc(`/customers/${companyID}/product/policyPackages/ISO27001keyDocuments/ismsManual`);

//     // Function to capture the expanded state of accordions
//     function getExpandedStates() {
//         const expandedRows = {};
//         document.querySelectorAll('.tableordion-content').forEach(row => {
//             const issueId = row.getAttribute('data-issue-id');
//             const isVisible = row.style.display !== 'none';
//             expandedRows[issueId] = isVisible;
//         });
//         return expandedRows;
//     }

//     // Function to reapply expanded states
//     function reapplyExpandedStates(expandedRows) {
//         document.querySelectorAll('.tableordion-row').forEach(row => {
//             const issueId = row.getAttribute('data-issue-id');
//             const contentRow = document.querySelector(`.tableordion-content[data-issue-id="${issueId}"]`);

//             if (expandedRows[issueId]) {
//                 contentRow.classList.remove('hidden');
//                 contentRow.style.display = 'table-row'; // Expand the row if it was expanded before
//                 row.querySelector('.collapse-toggle i').classList.replace('fa-square-chevron-down', 'fa-square-chevron-up');
//                 row.querySelector('.collapse-toggle i').style.color = '#F6961D';
//             } else {
//                 contentRow.classList.add('hidden');
//                 contentRow.style.display = 'none'; // Collapse if not expanded
//                 row.querySelector('.collapse-toggle i').classList.replace('fa-square-chevron-up', 'fa-square-chevron-down');
//                 row.querySelector('.collapse-toggle i').style.color = '#585555';
//             }
//         });
//     }

//     // Function to convert old issues to the new format
//     function convertOldIssueToNewFormat(oldIssue, type, issueKey) {
//         console.log(`Converting old issue ${oldIssue.issue} to new format for company ${companyID}`, {
//             // id will be assigned later
//             name: oldIssue.issue || 'Unknown',
//             description: '',
//             dateAdded: oldIssue.dateAdded || '',
//             type: type, // 'External' or 'Internal'
//             details: {
//                 issueType: '', // We might not have this info
//                 risks: [],
//                 objectives: [],
//                 legalObligations: [],
//                 frameworks: []
//             },
//             origin: {
//                 oldDocument: true,
//                 issueKey: issueKey,
//                 map: type === 'External' ? 'issuesExternal' : 'issuesInternal'
//             }
//         });
//         return {
//             // id will be assigned later
//             name: oldIssue.issue || 'Unknown',
//             description: '',
//             dateAdded: oldIssue.dateAdded || '',
//             type: type, // 'External' or 'Internal'
//             details: {
//                 issueType: '', // We might not have this info
//                 risks: [],
//                 objectives: [],
//                 legalObligations: [],
//                 frameworks: []
//             },
//             origin: {
//                 oldDocument: true,
//                 issueKey: issueKey,
//                 map: type === 'External' ? 'issuesExternal' : 'issuesInternal'
//             }
//         };
//     }

//     // Function to fetch old issues
//     async function getOldIssues() {
//         try {
//             const oldDocSnapshot = await oldDocumentRef.get();
//             const oldData = oldDocSnapshot.exists ? oldDocSnapshot.data() : {};

//             const issuesExternal = oldData.issuesExternal || {};
//             const issuesInternal = oldData.issuesInternal || {};

//             return { issuesExternal, issuesInternal };
//         } catch (error) {
//             console.error("Error fetching old data from Firestore:", error);
//             return { issuesExternal: {}, issuesInternal: {} };
//         }
//     }


//     if (enableRealTimeUpdates) {
//         // Real-time updates with onSnapshot
//         documentRef.onSnapshot(async docSnapshot => {
//             if (docSnapshot.exists) {
//                 // Initialize oldIssuesList
//                 let oldIssuesList = [];

//                 // Fetch old issues once
//                 const { issuesExternal, issuesInternal } = await getOldIssues();
//                 const newIssuesData = docSnapshot.data();

//                 // Capture expanded states before updating the table
//                 const expandedStates = getExpandedStates();

//                 // Get new issues as a list
//                 const newIssuesList = Object.values(newIssuesData);

//                 // Collect existing IDs
//                 const existingIds = new Set(newIssuesList.map(issue => issue.id));

//                 // Process old issues if not already processed
//                 if (oldIssuesList.length === 0) {
//                     // Convert old issues without assigning IDs yet
//                     let tempOldIssuesList = [];

//                     for (const [issueKey, issueData] of Object.entries(issuesExternal)) {
//                         const newIssue = convertOldIssueToNewFormat(issueData, 'External', issueKey);
//                         tempOldIssuesList.push(newIssue);
//                     }

//                     for (const [issueKey, issueData] of Object.entries(issuesInternal)) {
//                         const newIssue = convertOldIssueToNewFormat(issueData, 'Internal', issueKey);
//                         tempOldIssuesList.push(newIssue);
//                     }

//                     // Assign IDs to old issues, ensuring no conflicts
//                     let idCounter = 1;
//                     for (let oldIssue of tempOldIssuesList) {
//                         let newId;
//                         do {
//                             newId = `ISU-${idCounter}`;
//                             idCounter++;
//                         } while (existingIds.has(newId));

//                         oldIssue.id = newId;
//                         existingIds.add(newId); // Add to existing IDs to avoid future conflicts
//                         oldIssuesList.push(oldIssue);
//                     }
//                 }

//                 // Combine new and old issues
//                 const combinedIssues = [...newIssuesList, ...oldIssuesList];

//                 // Sort combined issues by ID
//                 const sortedIssues = combinedIssues.sort((a, b) => {
//                     return parseInt(a.id.split('-')[1]) - parseInt(b.id.split('-')[1]);
//                 });

//                 window.issueRegister = sortedIssues; // Update the global variable for the table rows

//                 // Update the table rows dynamically with sorted data
//                 const tableRows = sortedIssues.map((issue, index) => parseIssueRegisterRows(issue, index, expandedStates[issue.id] || false)).join('');
//                 document.querySelector('.tableordion-body').innerHTML = tableRows;

//                 // Reapply the expanded states
//                 reapplyExpandedStates(expandedStates);

//                 // Reinitialize Tableordion or any other UI components if necessary
//                 const accordions = new Tableordion('.tableordion-row');

//                 if (document.querySelector("[data-managedid='EditNewIssueModal'].show")) {
//                     let currentIssueID = document.querySelector("[data-managedid='EditNewIssueModal']").dataset.currentIssueId;

//                     let issueData = getIssueData(window.companyID, currentIssueID);

//                     issueData.then(data => {
//                         console.log('Issue data:', data);
//                         document.querySelector('[data-managedid="EditNewIssueModal"] #dateAdded_edit').value = data.dateAdded;
//                         document.querySelector('[data-managedid="EditNewIssueModal"] #description_edit').value = data.description;
//                         document.querySelector('[data-managedid="EditNewIssueModal"] #issueType_edit').value = data.details.issueType;
//                         document.querySelector('[data-managedid="EditNewIssueModal"] #type_edit').value = data.type;
//                         document.querySelector('[data-managedid="EditNewIssueModal"] #name_edit').value = data.name;
//                         document.querySelector('[data-managedid="EditNewIssueModal"] #risksSelected_edit').value = data.details.risks.map(risk => risk.riskID).join(', ');
//                         document.querySelector('[data-managedid="EditNewIssueModal"] #objectivesSelected_edit').value = data.details.objectives.map(objective => objective.id).join(', ');
//                         document.querySelector('[data-managedid="EditNewIssueModal"] #legalObligationsSelected_edit').value = data.details.legalObligations.map(legalObligation => legalObligation.id).join(', ');
//                         document.querySelector('[data-managedid="EditNewIssueModal"] #frameworksSelected_edit').value = data.details.frameworks.map(control => control.standard).join(', ');

//                         document.querySelector("[data-managedid='EditNewIssueModal']").classList.add('show');
//                         document.querySelector("[data-managedid='EditNewIssueModal']").dataset.currentIssueId = currentIssueID;
//                     }).catch(error => {
//                         console.error('Error getting issue data:', error);
//                     });
//                 }
//             } else {
//                 console.log("No document found at the specified path.");
//                 document.querySelector('.tableordion-body').innerHTML = "<p>No data available</p>";
//             }
//         }, error => {
//             console.error("Error fetching real-time updates from Firestore:", error);
//         });
//     } else {
//         // Fetch data only once (no real-time updates)
//         try {
//             // Initialize oldIssuesList
//             let oldIssuesList = [];

//             // Fetch old issues once
//             const { issuesExternal, issuesInternal } = await getOldIssues();

//             // Fetch new issues
//             const newDocSnapshot = await documentRef.get();
//             const newIssuesData = newDocSnapshot.exists ? newDocSnapshot.data() : {};
//             const newIssuesList = Object.values(newIssuesData);

//             // Collect existing IDs
//             const existingIds = new Set(newIssuesList.map(issue => issue.id));

//             // Convert old issues without assigning IDs yet
//             let tempOldIssuesList = [];

//             for (const issueData of Object.values(issuesExternal)) {
//                 const newIssue = convertOldIssueToNewFormat(issueData, 'External');
//                 tempOldIssuesList.push(newIssue);
//             }

//             for (const issueData of Object.values(issuesInternal)) {
//                 const newIssue = convertOldIssueToNewFormat(issueData, 'Internal');
//                 tempOldIssuesList.push(newIssue);
//             }

//             // Assign IDs to old issues, ensuring no conflicts
//             let idCounter = 1;
//             for (let oldIssue of tempOldIssuesList) {
//                 let newId;
//                 do {
//                     newId = `ISU-${idCounter}`;
//                     idCounter++;
//                 } while (existingIds.has(newId));

//                 oldIssue.id = newId;
//                 existingIds.add(newId); // Add to existing IDs to avoid future conflicts
//                 oldIssuesList.push(oldIssue);
//             }

//             // Combine new and old issues
//             const combinedIssues = [...newIssuesList, ...oldIssuesList];

//             // Sort combined issues by ID
//             const sortedIssues = combinedIssues.sort((a, b) => {
//                 return parseInt(a.id.split('-')[1]) - parseInt(b.id.split('-')[1]);
//             });

//             window.issueRegister = sortedIssues; // Update the global variable for the table rows

//             // Return sorted issues for display
//             return sortedIssues;
//         } catch (error) {
//             console.error("Error fetching data from Firestore:", error);
//             return null;
//         }
//     }
// }

import { db } from '../../config/main_config.js';

export async function fetchIssueRegister(companyID, enableRealTimeUpdates = false) {
    console.log(companyID);
    if (!companyID) {
        console.error("Company ID is required.");
        return null;
    }

    const documentRef = db.doc(`/customers/${companyID}/product/managementSystemGuide/issueRegister/register`);
    const oldDocumentRef = db.doc(`/customers/${companyID}/product/policyPackages/ISO27001keyDocuments/ismsManual`);

    // Function to capture the expanded state of accordions
    function getExpandedStates() {
        const expandedRows = {};
        document.querySelectorAll('.tableordion-content').forEach(row => {
            const issueId = row.getAttribute('data-issue-id');
            const isVisible = row.style.display !== 'none';
            expandedRows[issueId] = isVisible;
        });
        return expandedRows;
    }

    // Function to reapply expanded states
    function reapplyExpandedStates(expandedRows) {
        document.querySelectorAll('.tableordion-row').forEach(row => {
            const issueId = row.getAttribute('data-issue-id');
            const contentRow = document.querySelector(`.tableordion-content[data-issue-id="${issueId}"]`);

            if (expandedRows[issueId]) {
                contentRow.classList.remove('hidden');
                contentRow.style.display = 'table-row'; // Expand the row if it was expanded before
                row.querySelector('.collapse-toggle i').classList.replace('fa-square-chevron-down', 'fa-square-chevron-up');
                row.querySelector('.collapse-toggle i').style.color = '#F6961D';
            } else {
                contentRow.classList.add('hidden');
                contentRow.style.display = 'none'; // Collapse if not expanded
                row.querySelector('.collapse-toggle i').classList.replace('fa-square-chevron-up', 'fa-square-chevron-down');
                row.querySelector('.collapse-toggle i').style.color = '#585555';
            }
        });
    }

    // Function to convert old issues to the new format
    function convertOldIssueToNewFormat(oldIssue, type, issueKey) {
        return {
            // id will be assigned later
            name: oldIssue.issue || 'Unknown',
            description: '',
            dateAdded: oldIssue.dateAdded || '',
            type: type, // 'External' or 'Internal'
            details: {
                issueType: '', // We might not have this info
                risks: [],
                objectives: [],
                legalObligations: [],
                frameworks: []
            },
            origin: {
                oldDocument: true,
                issueKey: issueKey,
                map: type === 'External' ? 'issuesExternal' : 'issuesInternal'
            }
        };
    }

    // Function to fetch old issues
    async function getOldIssues() {
        try {
            const oldDocSnapshot = await oldDocumentRef.get();
            const oldData = oldDocSnapshot.exists ? oldDocSnapshot.data() : {};

            const issuesExternal = oldData.issuesExternal || {};
            const issuesInternal = oldData.issuesInternal || {};

            return { issuesExternal, issuesInternal };
        } catch (error) {
            console.error("Error fetching old data from Firestore:", error);
            return { issuesExternal: {}, issuesInternal: {} };
        }
    }

    if (enableRealTimeUpdates) {
        // Real-time updates with onSnapshot
        documentRef.onSnapshot(async docSnapshot => {
            if (docSnapshot.exists) {
                // Initialize oldIssuesList
                let oldIssuesList = [];

                // Fetch old issues
                const { issuesExternal, issuesInternal } = await getOldIssues();
                const newIssuesData = docSnapshot.data();

                // Capture expanded states before updating the table
                const expandedStates = getExpandedStates();

                // Get new issues as a list
                const newIssuesList = Object.values(newIssuesData);

                // Collect existing IDs
                const existingIds = new Set(newIssuesList.map(issue => issue.id));

                // Convert old issues without assigning IDs yet
                let tempOldIssuesList = [];

                for (const [issueKey, issueData] of Object.entries(issuesExternal)) {
                    const newIssue = convertOldIssueToNewFormat(issueData, 'External', issueKey);
                    tempOldIssuesList.push(newIssue);
                }

                for (const [issueKey, issueData] of Object.entries(issuesInternal)) {
                    const newIssue = convertOldIssueToNewFormat(issueData, 'Internal', issueKey);
                    tempOldIssuesList.push(newIssue);
                }

                // Extract origin identifiers from newIssuesList
                const originsInNewIssues = newIssuesList
                    .filter(issue => issue.origin && issue.origin.oldDocument)
                    .map(issue => ({
                        map: issue.origin.map,
                        issueKey: issue.origin.issueKey
                    }));

                // Filter oldIssuesList to exclude issues that are already in newIssuesList based on origin
                oldIssuesList = tempOldIssuesList.filter(oldIssue => {
                    const origin = oldIssue.origin;
                    if (!origin) {
                        return true; // Keep issues without origin
                    }
                    // Exclude if the origin is present in newIssuesList
                    return !originsInNewIssues.some(newOrigin =>
                        newOrigin.map === origin.map && newOrigin.issueKey === origin.issueKey
                    );
                });

                // Assign IDs to remaining old issues, ensuring no conflicts
                let idCounter = 1;
                for (let oldIssue of oldIssuesList) {
                    let newId;
                    do {
                        newId = `ISU-${idCounter}`;
                        idCounter++;
                    } while (existingIds.has(newId));

                    oldIssue.id = newId;
                    existingIds.add(newId); // Add to existing IDs to avoid future conflicts
                }

                // Combine new and old issues
                const combinedIssues = [...newIssuesList, ...oldIssuesList];

                // Sort combined issues by ID
                const sortedIssues = combinedIssues.sort((a, b) => {
                    return parseInt(a.id.split('-')[1]) - parseInt(b.id.split('-')[1]);
                });

                window.issueRegister = sortedIssues; // Update the global variable for the table rows

                // Update the table rows dynamically with sorted data
                const tableRows = sortedIssues.map((issue, index) => parseIssueRegisterRows(issue, index, expandedStates[issue.id] || false)).join('');
                waitForElement('.tableordion-body').then(() => {
                    document.querySelector('.tableordion-body').innerHTML = tableRows;
                });

                // Reapply the expanded states
                reapplyExpandedStates(expandedStates);

                // Reinitialize Tableordion or any other UI components if necessary
                const accordions = new Tableordion('.tableordion-row');

                // Additional code for handling modals (if needed)

            } else {
                console.log("No document found at the specified path.");
                waitForElement('.tableordion-body').then(() => {
                    document.querySelector('.tableordion-body').innerHTML = "<p>No data available</p>";
                });
            }
        }, error => {
            console.error("Error fetching real-time updates from Firestore:", error);
        });
    } else {
        // Fetch data only once (no real-time updates)
        try {
            // Initialize oldIssuesList
            let oldIssuesList = [];

            // Fetch old issues
            const { issuesExternal, issuesInternal } = await getOldIssues();

            // Fetch new issues
            const newDocSnapshot = await documentRef.get();
            const newIssuesData = newDocSnapshot.exists ? newDocSnapshot.data() : {};
            const newIssuesList = Object.values(newIssuesData);

            // Collect existing IDs
            const existingIds = new Set(newIssuesList.map(issue => issue.id));

            // Convert old issues without assigning IDs yet
            let tempOldIssuesList = [];

            for (const [issueKey, issueData] of Object.entries(issuesExternal)) {
                const newIssue = convertOldIssueToNewFormat(issueData, 'External', issueKey);
                tempOldIssuesList.push(newIssue);
            }

            for (const [issueKey, issueData] of Object.entries(issuesInternal)) {
                const newIssue = convertOldIssueToNewFormat(issueData, 'Internal', issueKey);
                tempOldIssuesList.push(newIssue);
            }

            // Extract origin identifiers from newIssuesList
            const originsInNewIssues = newIssuesList
                .filter(issue => issue.origin && issue.origin.oldDocument)
                .map(issue => ({
                    map: issue.origin.map,
                    issueKey: issue.origin.issueKey
                }));

            // Filter oldIssuesList to exclude issues that are already in newIssuesList based on origin
            oldIssuesList = tempOldIssuesList.filter(oldIssue => {
                const origin = oldIssue.origin;
                if (!origin) {
                    return true; // Keep issues without origin
                }
                // Exclude if the origin is present in newIssuesList
                return !originsInNewIssues.some(newOrigin =>
                    newOrigin.map === origin.map && newOrigin.issueKey === origin.issueKey
                );
            });

            // Assign IDs to remaining old issues, ensuring no conflicts
            let idCounter = 1;
            for (let oldIssue of oldIssuesList) {
                let newId;
                do {
                    newId = `ISU-${idCounter}`;
                    idCounter++;
                } while (existingIds.has(newId));

                oldIssue.id = newId;
                existingIds.add(newId); // Add to existing IDs to avoid future conflicts
            }

            // Combine new and old issues
            const combinedIssues = [...newIssuesList, ...oldIssuesList];

            // Sort combined issues by ID
            const sortedIssues = combinedIssues.sort((a, b) => {
                return parseInt(a.id.split('-')[1]) - parseInt(b.id.split('-')[1]);
            });

            window.issueRegister = sortedIssues; // Update the global variable for the table rows

            // Return sorted issues for display
            return sortedIssues;

        } catch (error) {
            console.error("Error fetching data from Firestore:", error);
            return null;
        }
    }
}